<template>
	<div
	class="pt-2 pb-2 clearfix"
	:class="containerClass"
	v-touch:tap="tapHandler"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>
		<template v-if="data">
			<div class="unread-icon" v-if="!read"></div>
			<p class="mt-0 mb-0" :class="{'text-danger': (data.seriousconcern == 1)}">
				<b-icon v-if="data.seriousconcern == 1" icon="exclamation-triangle" class="icon-danger mr-1"></b-icon>
				<strong>{{ (data.message_subject?data.message_subject:$t('no-subject')) }}</strong>
			</p>
			<p class="mt-0 mb-0 small">{{ data.DisplayName }}</p>
			<p class="mt-0 mb-0 small" v-if="datetime">{{ datetime }}</p>
		</template>

		<template v-else>

			<div class="float-left">
				<div class="skeleton midnight h20 w200 mb-3"></div>
				<div class="skeleton midnight h20 w50"></div>
			</div>
			<div class="float-right">
				<div class="skeleton midnight h20 w200"></div>
			</div>
		</template>


	</div>
</template>

<script>
export default {
	props: ['data', 'selectedItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		tapHandler() {
			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		}
	},
	computed: {
		selected() {
			return this.selectedItem && this.selectedItem.message_id == this.data.message_id;
		},
		datetime(){
			if(this.data.created){
				var dateObj = this.$datetime.getDateObjectFromDateTimeField(this.data.created);
				if(dateObj){
					return this.$d(dateObj, 'datetime');
				}
				return null;
			}
			return null;
		},
		read() {
			return this.data.message_seen === '1' ? true : false;
		},
		containerClass() {
			const classArr = [];
			if(this.selected) {
				classArr.push('active')
			}
			if (this.data && !this.read) {
				classArr.push('message--unread');
			}
			return classArr.join(' ');
		}
	}
};
</script>
